import { compose, withProps } from 'recompose'
import SummaryItem from './SummaryItem'
import kebabCase from 'lodash/kebabCase'

const withImprovedProps = withProps(({ title, dataAttrPrefix }) => ({
  dataAttr: !dataAttrPrefix ? kebabCase(title) : kebabCase(dataAttrPrefix)
}))

export default compose(
  withImprovedProps
)(SummaryItem)
